import { CbhFeatureFlag } from "../FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "../FeatureFlags/useCbhFlag";

export function useLicenseFieldsRequirementsFlag() {
  return useCbhFlag(CbhFeatureFlag.HCP_LICENSE_FIELDS_REQUIREMENTS, {
    defaultValue: {},
  });
}
